import Dexie from "dexie";
import db from "../Db";

var DeleteEtatTerrain = Dexie.async(function* () {
  yield db.open();
  yield db.ETAT_TERRAIN.clear();
});

export default DeleteEtatTerrain;
